// extracted by mini-css-extract-plugin
module.exports = {"MAP_CART_ITEMS":"MapCartItems_MAP_CART_ITEMS__2gqGK"};